import { START_FLOW, END_FLOW } from "../actions/flow";

export const getFlow = (flowId) => (state) => state.flows[flowId];

export const getFlowEnd = (flowId) => (action) => action.type === END_FLOW && action.payload.flowId === flowId;

export const getFlowStart = (flowId) => (action) => action.type === START_FLOW && action.payload.flowId === flowId;
